import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@unico-people/shared/utils/environments';

@Injectable({
  providedIn: 'root'
})
export class DataAccessModulesService {
  private url: string = environment.url_admission_api;

  constructor(private http: HttpClient) {}

    /**
     * Get modules permissions
     * @param access_token JWT token
     */
    read(access_token): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: `Bearer ${access_token}`
            }),
            withCredentials: true
        };
        return this.http.get(`${this.url}/modules`, httpOptions);
    }
}
